import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { DocumentUploadModel } from '../../../types/dido-document-upload-model.type';

@Component({
    selector: 'dido-documenten-control-dialog-intern-email-meta',
    templateUrl: './dialog-intern-email-meta.html',
    styleUrls: ['./dialog-intern-email-meta.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [DatePipe]
})
export class DidoDocumentenControlDialogInternEmailMeta {
    readonly selectedDocument = input.required<DocumentUploadModel>();
}
